import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@material-ui/core/styles';
import { WidgetHeader } from '../WidgetHeader';
import { Loader, TextDelayedLoader } from '../Loader';
const MainWrap = styled.div.withConfig({
  displayName: "WidgetFallback__MainWrap",
  componentId: "sc-1gpzjod-0"
})([""]);
const Body = styled.div.withConfig({
  displayName: "WidgetFallback__Body",
  componentId: "sc-1gpzjod-1"
})(["", " display:flex;flex-direction:column;border:2px solid ", ";overflow:scroll;align-items:flex-start;background-color:", ";min-height:279px;position:relative;"], props => props.smallWidget ? `min-height: 279px;` : `height: ${props.fullSizeHeight}px;`, props => props.theme.palette.background.paper, props => props.theme.palette.background.paper);

var _ref = /*#__PURE__*/React.createElement(Loader, null);

// Note: the fallback may be or a Loader when measures embedded in an app or
// the widget placeholder when in dashboard
export const WidgetFallback = /*#__PURE__*/React.memo(({
  noWidgetHeader,
  appTitle,
  smallWidget,
  embedded,
  name
}) => {
  const {
    props: {
      dashboard: {
        fullSizeHeight
      }
    }
  } = useTheme();
  return embedded && !noWidgetHeader ? /*#__PURE__*/React.createElement(MainWrap, {
    id: "mainwrap"
  }, /*#__PURE__*/React.createElement(WidgetHeader, {
    appTitle: appTitle === null || appTitle === void 0 ? void 0 : appTitle.toLocaleUpperCase(),
    smallWidget: true,
    noIcon: true
  }), /*#__PURE__*/React.createElement(Body, {
    id: "body",
    smallWidget: smallWidget,
    fullSizeHeight: fullSizeHeight
  }, /*#__PURE__*/React.createElement(TextDelayedLoader, {
    smallWidget: smallWidget,
    name: name
  }))) : _ref;
});
export default WidgetFallback;